<template>
    <ldc-dialog
        :title="title"
        :colorTitle="colorTitle"
        :clickoutside="true"
        width="50%"
        :fullscreen="$detect == 'mobile'"
        :class="{
            'product-dialog' : true,
            'product-dialog-web' : $detect == 'web',
            'modal-register-vip': $detect == 'web',
            'modal-mobile-vip position-relative': $detect == 'mobile',
        }"
        :visible.sync="dialog">
        <div class="content-modal py-3 px-10px">
            <form >
                <div class="form-group">
                    <label for="exampleFormControlTextarea1">Từ khóa</label>
                    <textarea class="form-control" v-model="form.keywords" id="exampleFormControlTextarea1" rows="3" placeholder="Nhập nhiều từ khóa cách nhau bởi dấu ','.VD: (a,b,c,...)"></textarea>
                </div>
                <div class="custom-control custom-switch">
                    <input type="checkbox" v-model="form.active" class="custom-control-input" id="customSwitch1">
                    <label class="custom-control-label" for="customSwitch1">Hoạt động</label>
                </div>
            </form>


        </div>
        <div class="footer-modal text-center">
            <button :class="{
                    'btn btn-primary my-10px mr-10px': true,
                    'btn-sm': $detect == 'web'
                }"
                    @click="submit()"
            >Xác nhận</button>
        </div>
    </ldc-dialog>
</template>
<script>
export default {
    props: ['visible', 'data'],
    data() {
        return {
            dialog: false,
            title: '',
            actionMuti: false,
            loading: false,
            source_pay: this.$detect == 'web' ? 0: 1,
            checkDataLink : false,
            colorTitle : '',
            form : {
                keywords : '',
                active : true
            },
            edit : false,
            error : {}
        }
    },
    watch: {
        visible(val){
            this.dialog = val;
        },
        dialog(val){
            this.$emit('update:visible', val);
        },
        data(val){
            this.form.keywords = val.rej_keyword;
            this.form.active = val.rej_active == 1 ? true : false;
            this.edit = true
        },
    },
    created (){
        this.title = 'Thêm mới';
        this.colorTitle = '#0c81f6';
        this.product = this.data;
    },
    computed: {

    },
    methods: {
        async submit(){
            let form = {};
            form.keywords = this.form.keywords;
            form.active = this.form.active ? 1 : 0;
            await apiPost('/v2/profile/keyword-reject', form).then(res => {
                if(res.success == 1){
                    this.$message({
                        message: res.message,
                        type: 'success',
                        center: true,
                    });
                    this.$router.push({
                        name: 'keyword-reject',
                        query : {
                            time : Date.now()
                        }
                    });
                }else{
                    this.$message({
                        type: 'error',
                        message: res.message,
                        center: true,
                    });
                }
            }).catch(err => {
                if(err.status == 422){
                    this.error = err.data.error;
                    this.$message({
                        message: 'Vui lòng kiểm tra lại các trường',
                        type: 'warning',
                        center: true,
                    });
                }
            });
           this.$emit('update:visible', false);
        },
    }
}
</script>
<style lang="scss">
.w-35{
    width : 35%;
}
.w-65{
    width: 65%;
}
.modal-mobile-vip{
    &.modal-HappyLink{
        .title-dialog{
            background : #dc3545;
        }
    }
}

.modal-mobile-vip{
    .content-modal{
        margin-top : 0;
    }
    &.modal-HappyLink {
        .footer-modal{
            .btn-confirm, .btn-danger{
                width: 40%;
            }
        }
    }
}
.input-time-mobile{
    .input-time-mobile{
        width : 174px!important;
    }
}
.modal-register-vip, .modal-mobile-vip{
    &.modal-HappyLink{
        .title-dialog {
            border-bottom: 1px solid #dc3545;
        }
        .footer-modal{
            border-top: 1px solid #dc3545;
            .btn-confirm{
                color: white;
                background : #dc3545;
            }
        }
    }
    &.modal-dght {
        .title-dialog {
            border-bottom: 1px solid #20c997;
        }
        .footer-modal{
            border-top: 1px solid #20c997;
            .btn-confirm{
                color: white;
                background : #20c997;
            }
        }
    }
}
.product-dialog{
    &.product-dialog-web{
        .content-modal .value .input-link{
            width: 143px;
        }
    }
    .content-change-time{
        .date-change{
            height: 35px;
            border-radius: 4px;
            border: 1px solid rgba(0, 0, 0, 0.2);
            color: #606266;
            outline: none;
            cursor: pointer;
        }
    }
    .content-modal{
        .value{
            select{
                height: 35px;
                width: 155px;
                border-radius: 4px;
                border: 1px solid rgba(0, 0, 0, 0.2);
                color: #606266;
                outline: none;
                cursor: pointer;
            }
            span{
                height: 35px;
                border-radius: 4px;
                border: 1px solid rgba(0, 0, 0, 0.2);
                color: #606266;
                outline: none;
                padding: 0 10px;
                cursor: pointer;
                line-height: 35px;
            }
            .select-dght{
                height: 35px;
                border-radius: 4px;
                border: 1px solid rgba(0, 0, 0, 0.2);
                color: #606266;
                outline: none;
                cursor: pointer;
                width: 155px;
            }
            .input-link{

                &.input-link-mobile{
                    width : 82px!important;
                    border : 1px solid #bdc3c7;
                    padding-right : 5px;
                    border-radius : 4px!important;
                }
            }
            .input-estore_quantity{
                width : 180px;
                &.back-brow{
                    background: #f1f0f0;
                }
                &.input-link-mobile{
                    width : 85px!important;
                    border : 1px solid #bdc3c7;
                    padding-right : 5px;
                    border-radius : 4px!important;
                }
            }
            .input-price-vip{
                width: 155px;
                color : #dc3545;
            }
        }
    }
}
@media (max-width: 370px) {
    .pro-duct{
        .product-dialog{
            .main-dialog{
                .name{
                    font-size : 14px;
                }
                .value{
                    select{
                        width : 110px;
                    }
                    .input-link-mobile{
                        width: 57px !important;
                    }
                    span{
                        padding : 0 5px;
                    }
                    .input-estore_quantity{
                        &.input-link-mobile{
                            width: 74px !important;
                        }
                    }
                }
            }
        }
    }
}
</style>
